import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=5f312060&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"
import style0 from "./AppView.vue?vue&type=style&index=0&id=5f312060&prod&scoped=true&lang=css"
import style1 from "./AppView.vue?vue&type=style&index=1&id=5f312060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f312060",
  null
  
)

export default component.exports